export const SET_NOTHING = 'SET_NOTHING';
export const INITIATE_EVENT = 'INITIATE_EVENT';